/* leaf_lead_submitted — Digioh submit bridge for /pages/find-your-watch */
(function () {
  window.dataLayer = window.dataLayer || [];
  var PAGE_MATCH = '/pages/find-your-watch';

  function onThisPage(p) {
    var path = (p && p.digioh_url_path) || window.location.pathname || '';
    return path.indexOf(PAGE_MATCH) !== -1 ||
           (window.location.href || '').indexOf(PAGE_MATCH) !== -1;
  }

  function publish(p) {
    if (!onThisPage(p)) return;
    if (!window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') return;
    // Optional consent gate — uncomment to suppress the emit pre-consent:
    // if (!(window.Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed())) return;
    p = p || {};
    Shopify.analytics.publish('leaf_lead_submitted', {
      lead_type: 'find_your_watch'
    });
    console.log("Sending event is succesful")
  }

  var _push = window.dataLayer.push;
  window.dataLayer.push = function () {
    var r = _push.apply(this, arguments);
    try {
      for (var i = 0; i < arguments.length; i++) {
        var a = arguments[i];
        if (!a) continue;
        if (a[0] === 'event' && a[1] === 'digioh_box_submit') publish(a[2]);  // gtag-style
        else if (a.event === 'digioh_box_submit') publish(a);                  // GTM object-style
      }
    } catch (e) {}
    return r;
  };
})();